var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18815 9.8215L0.277344 5.75476L1.64613 4.3314L4.18815 6.97478L10.641 0.264648L12.0098 1.68801L4.18815 9.8215Z",
    fill: "#F3FAF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThick);
export default __webpack_public_path__ + "static/media/thick.c3adec274a8d1914de4f16d6b6ca9797.svg";
export { ForwardRef as ReactComponent };